import styled from 'styled-components';
import { simpleFlex, takeColor } from 'theme/tools';

export const Container = styled.div``;

export const PrintView = styled.div`
  padding: 5px 22px 0px 22px;
  position: relative;
`;

export const ContainerButtons = styled.div`
  ${simpleFlex}
  justify-content: center;
  padding: 35px 0px;
  position: sticky;
  bottom: -35px;
  background-color: ${takeColor('white')};

  button:first-child {
    margin-right: 35px;
  }
`;

export const TitleFornova = styled.div`
  text-align: center;
  font-size: 25px;
  color: black;
  font-weight: bold;
  margin-bottom: 25px;

  @media print {
    & {
      font-size: 15px;
    }
  }
`;

export const NoResults = styled.div`
  ${simpleFlex}
  justify-content: center;
  flex-direction: column;
  min-height: 200px;
`;
